/* eslint-disable react/no-danger */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import injectIntl, { intlShape } from 'common/injectIntl';
import SearchFilter from 'common/search/SearchFilter';
import ProviderList from './ProviderList';
import Tier1ProviderGrid from './Tier1ProviderGrid';
import DMVPDButton from './DMVPDButton';
import { sortByRank as sortProvidersByRank } from 'lib/util';
import { providersSelector } from 'common/selectors/providerSelector';
import {
    showDMVPDUpsellSelector,
    isESPNAppSelector,
    faqUrlSelector,
    isIntlSelector,
    upsellUrlSelector
} from 'common/selectors/appSelector';

/**
 * getTier1Providers - Returns a list of filtered providers whose tier property is 1.
 * For international providers, the list is sorted by rank.
 *
 * @param {Array} providers - Array of provider objects to be filtered
 * @param {boolean} isIntl = false - Flag to determine if app is international
 *
 * @return {Array} - Array of filtered/sorted providers
 */
function getTier1Providers(providers, isIntl = false) {
    const tierOneProviders = providers.filter((provider) => (provider.tier === 1));
    // Tier 1 Providers will only be sorted if 1) isInternational 2) the `rank` property is defined
    return (isIntl === true) ? tierOneProviders.sort(sortProvidersByRank) : tierOneProviders;
}

class ProviderDialog extends Component {
    constructor(props) {
        super(props);
        this.state = { searchFilter: '', showTierOne: true };
        this.onFilterInputChange = this.onFilterInputChange.bind(this);
        this.onFilterInputFocus = this.onFilterInputFocus.bind(this);
    }

    onFilterInputChange(event) {
        const searchFilter = event.target.value;
        const { isESPNApp } = this.props;
        // Show tier one if is web picker or if user has backspaced and search filter is empty
        const showTierOne = (!isESPNApp) || searchFilter === '';
        this.setState({ searchFilter, showTierOne });
    }

    onFilterInputFocus() {
        if (this.props.isESPNApp) {
            this.setState({ showTierOne: false, searchFilter: 'zzzzz' });
        }
    }

    render() {
        const { messages,
            faqUrl,
            upsellUrl,
            intl: { formatMessage },
            providers,
            providerSelect,
            showDMVPDUpsell,
            showTierOneProviders,
            isESPNApp,
            isIntl,
            providerStyle,
            providerClass
        } = this.props;

        // FIXME: Supposed to use `FormattedMessage` from `react-intl` but can't use it because of css `>span`
        const description = formatMessage(messages['provider.dialog.description'], {
            noCost: `<span>${formatMessage(messages['provider.dialog.description.noCost'])}</span>`,
            faq: `<a target="_blank" href="${faqUrl}" class="watchProvider__link">
                ${formatMessage(messages['provider.dialog.faq.label'])}</a>`,
            help: `<a target="_blank" href="${formatMessage(messages['provider.dialog.help.link'])}" class="watchProvider__link">
                ${formatMessage(messages['provider.dialog.help.label'])}</a>`
        });
        const tier1Providers = getTier1Providers(providers, isIntl);
        const tier1Grid = (showTierOneProviders && tier1Providers.length > 0) ? (
            <div>
                <Tier1ProviderGrid isIntl={isIntl} providers={tier1Providers} providerSelect={providerSelect} />
            </div>
        ) : null;

        let preSearch;
        let postSearch;
        let modalTitle;
        let tierOne;
        let subtitle;
        const searchFilter = (
            <SearchFilter
                handleChange={this.onFilterInputChange}
                handleInputFocus={this.onFilterInputFocus}
                placeholder={formatMessage(messages['search.filter.placeholder'])}
            />
        );

        if (isESPNApp) {
            preSearch = searchFilter;
            subtitle = formatMessage(messages['provider.dialog.subtitle']);
        } else {
            modalTitle = (
                <h1 className="watchProvider__title">
                    <span>{formatMessage(messages['provider.dialog.title'])}</span>
                </h1>
            );
            postSearch = searchFilter;
        }

        const dmvpdButton = showDMVPDUpsell ?
            (
                <DMVPDButton
                    text={formatMessage(messages['provider.dialog.button.text'])}
                    link={upsellUrl}
                />
            ) : null;

        if (this.state.showTierOne) {
            tierOne = (
                <div>
                    <p
                        className="watchProvider__desc"
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                    {tier1Grid}
                    {dmvpdButton}
                </div>
            );
        }

        return (
            <div>
                {modalTitle}
                <div style={providerStyle} className={providerClass}>
                    {preSearch}
                    {tierOne}
                    {postSearch}
                    <ProviderList
                        filter={this.state.searchFilter}
                        header={subtitle}
                        providers={providers}
                        providerSelect={providerSelect}
                    />
                </div>
            </div>
        );
    }
}

ProviderDialog.propTypes = {
    providers: PropTypes.array,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired,
    providerSelect: PropTypes.func,
    showDMVPDUpsell: PropTypes.bool,
    isESPNApp: PropTypes.bool,
    isIntl: PropTypes.bool,
    showTierOneProviders: PropTypes.bool,
    providerStyle: PropTypes.object,
    providerClass: PropTypes.string,
    faqUrl: PropTypes.string,
    upsellUrl: PropTypes.string
};

ProviderDialog.defaultProps = {
    providers: [],
    showProviderDialog: false,
    isESPNApp: false,
    isIntl: false,
    showTierOneProviders: true
};

const mapStateToProps = (state) => ({
    providers: providersSelector(state),
    isESPNApp: isESPNAppSelector(state),
    isIntl: isIntlSelector(state),
    showDMVPDUpsell: showDMVPDUpsellSelector(state),
    upsellUrl: upsellUrlSelector(state),
    faqUrl: faqUrlSelector(state)
});

export default (connect(mapStateToProps)(injectIntl(ProviderDialog)));



// WEBPACK FOOTER //
// ./app/common/chooseProvider/ProviderDialog.js